<template>
<div ref="slider" class="pp-mobile-cover-art-slider" @scroll="onScroll" @touchstart="onTouchStart" @touchmove="onTouchMove">
    <div v-for="track in nearHistory" class="pp-mobile-cover-art-slider__slide">
        <img :src="track.album.artwork">
    </div>
    <a v-if="currentTrack" class="pp-mobile-cover-art-slider__slide pp-mobile-cover-art-slider__slide--current" :href="href" target="_blank">
        <img :src="currentTrack.album.artwork">
    </a>
    <div v-for="track in nearQueue" class="pp-mobile-cover-art-slider__slide">
        <img :src="track.album.artwork">
    </div>
</div>
</template>

<script>
import EventBus from '../EventBus.js';

export default {
    props: {
        nearHistory: Array,
        nearQueue: Array,
        currentTrack: Object,
        href: String,
    },
    data() {
        return {
            lastScrollPos: 0,
            scrollChangeEnabled: false,
        };
    },
    watch: {
        currentTrack() {
            var slider = this.$refs.slider;

            var scrollX = slider.scrollWidth / 2;
            slider.scroll({ top: 0, left: scrollX, behavior: 'smooth' });
            
            setTimeout(() => {
                this.scrollChangeEnabled = true;
            }, 1000);
        },
    },
    methods: {
        onScroll(e) {
            e.preventDefault();
            return false;
        },
        onTouchStart(e) {
            return false; 

            var touchX = e.touches[0].pageX;
            this.lastScrollPos = touchX;

            console.log('onTouchStart', {
                touchX,
                e
            });
        },
        onTouchMove(e) {
            return false;

            if (!this.scrollChangeEnabled) {
                return false;
            }


            var slider = this.$refs.slider;
            var touchX = e.touches[0].pageX;

            console.log('onTouchMove', {
                touchX,
                e
            });

            if (touchX > this.lastScrollPos) {
                console.log('scroll left');
                EventBus.emit('controls.previous');
            }
            if (touchX < this.lastScrollPos) {
                console.log('scroll right');
                EventBus.emit('controls.next');
            }

            this.lastScrollPos = touchX;
            this.scrollChangeEnabled = false;
            return false;
        },
    }
}
</script>


<style lang="css">
.pp-mobile-cover-art-slider { 
    width: 100%;
    height: 300px;

    overflow-x: scroll;
    display: flex;
    flex-wrap: nowrap;

    align-items: center;
}
.pp-mobile-cover-art-slider__slide { 
    flex-shrink: 0;
    width: 100%;
    height: 100%;

    display: flex;
    align-items: center;
    justify-content: center;
}
.pp-mobile-cover-art-slider__slide img {
    max-width: 100%;
    max-height: 100%;
}
.pp-mobile-cover-art-slider__slide--current { 
}
</style>



// WEBPACK FOOTER //
// MobileCoverArtSlider.vue?50a89e92